import setupFeeMap from "./setupFeeMap";

export default {
  methods:
  {
    recalcPrices() {
      this.$store.dispatch("Configuration/loadCO", {
        axios: this.$axios,
        pid: sessionStorage.getItem("pid"),
        billing: this.billing,
      });
    },
  },
  computed:
  {
    fieldHint() {
      return this.bwCO?.options[0].recurring != '0.00' ? this.bwCO?.options[0].name : ''
    },
    bwCO() {
      return this.$store.state.Configuration.co.find(
        (i) => i.optionraw.trim().startsWith("bandwidth")
      );
    },
    price() {
      if (this.bwCO) {
        const bw = this.bandwidth > 0 ? this.bandwidth : 1;
        const billingset = this.billing === 'onetime' ? 'monthly' : this.billing
        const price = parseInt(bw) * this.bwCO?.options[0].recurring +
          parseFloat(
            this.$store.state.Configuration?.pricing?.rawpricing[
            billingset
            ]
          );
        return (
          this.setupFee +
          this.formatCurrency(
            price
          )
        );
      }
      return "";
    },
    setupFee() {
      if (this.billing) {
        let setupFee =
          this.bwCO.selectedsetup +
          parseFloat(
            this.$store.state.Configuration?.pricing?.rawpricing[
            setupFeeMap[this.billing]
            ]
          );
        return setupFee > 0.0
          ? this.formatCurrency(setupFee) + " setup + "
          : "";
      }
      return "";
    },

  }
}